import React from 'react';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { LegalNoticeUi } from './ui';
import { useLegalNotice } from './useLegalNotice';
import { StaticPageLoadingPlaceholder } from '@cp-shared-15/frontend-ui';

const LegalNoticeWithHandlers = withLoadingAndNoConnectionHandler(LegalNoticeUi);

export const LegalNotice: React.FC = () => {
    const { cmsContent: legalNotice, isLoading, loadingError } = useLegalNotice();

    return (
        <LegalNoticeWithHandlers
            isLoading={isLoading}
            legalNotice={legalNotice}
            hasError={!!loadingError}
            loadingPlacehloder={<StaticPageLoadingPlaceholder />}
        />
    );
};
